export const TEXT = {
  ar: {
    tabs: { inbox: "التنبيهات", send: "إرسال تنبيه", builder: "بناء القوالب" },
    metrics: { total: "إجمالي التنبيهات", unread: "غير مقروء", read: "مقروء" },
    filters: {
      all: "الكل",
      menu: "قائمة الطعام",
      manager: "مدير الحساب",
      report: "التقارير",
      ticket: "التذاكر",
      billing: "الفوترة",
      operations: "العمليات",
      allRestaurants: "جميع المطاعم",
      allBranches: "كل الفروع",
      allStatuses: "كل الحالات",
      unread: "غير مقروء",
      read: "مقروء",
      noNotifications: "لا توجد تنبيهات ضمن هذا الفلتر",
    },
    send: {
      success: "تم إرسال التنبيه بنجاح",
      successSub: "سيصل للمطعم فوراً",
      newNotification: "تنبيه جديد",
      category: "الفئة",
      general: "إشعارات عامة",
      ticket: "التذاكر",
      hint: "قائمة الطعام / التقارير / مدير الحساب تظهر دائماً لصاحب الحساب وكل فروعه معاً. خيار الخصوصية لفرع محدد متاح فقط للتذاكر.",
      template: "القالب",
      preview: "معاينة التنبيه",
      recipientPreview: "المستلم:",
      recipientEmpty: "—",
      selectTemplateAr: "اختر قالباً لتظهر المعاينة...",
      selectTemplateEn: "Select a template to preview...",
      arabic: "عربي",
      english: "English",
      recipient: "المستلم",
      single: "مطعم واحد",
      multiple: "عدة مطاعم",
      recipientRestaurant: "المطعم المستلم",
      selectRestaurant: "— اختر المطعم —",
      recipientRestaurants: "المطاعم المستلمة",
      scope: "نطاق التنبيه",
      ownerAndBranches: "المالك + كل الفروع",
      ownerOnly: "المالك فقط",
      branch: "فرع محدد",
      recipientBranch: "الفرع المستلم",
      selectBranch: "— اختر الفرع —",
      visibility: "من يشاهد هذا التنبيه؟",
      ownerSeesToo: "يظهر أيضاً لصاحب الحساب (المالك) بالإضافة للفرع المحدد",
      ownerSeesHint: "إلغاء التفعيل يجعل التنبيه خاصاً بهذا الفرع فقط، ولا يظهر لصاحب الحساب.",
      note: "تفاصيل إضافية (اختياري)",
      notePlaceholder: "أضف تفاصيل يدوية...",
      send: "إرسال التنبيه",
      sentNotifications: "التنبيهات المرسلة",
      noSent: "لا توجد تنبيهات مرسلة بعد.",
      details: "تفاصيل: ",
      supportTeam: "فريق الدعم",
      you: "أنت",
      now: "الآن",
      privateBranch: "خاص بالفرع فقط",
      ownerVisible: "يظهر أيضاً للمالك",
      restaurantsCount: "مطاعم",
    },
    builder: {
      title: "بناء القوالب",
      intro: "أنشئ وعدّل وحذف قوالب التنبيهات الخاصة بكل قسم. القوالب تُحفظ بشكل دائم بهذا المتصفح وتظهر مباشرة بتبويب \"إرسال تنبيه\".",
      section: "القسم",
      templates: "القوالب",
      newTemplate: "قالب جديد",
      editTemplate: "تعديل القالب",
      noTemplates: "لا توجد قوالب بهذا القسم بعد.",
      templateNameAr: "اسم القالب (عربي)",
      templateNameEn: "Template Name (English)",
      bodyAr: "نص التنبيه (عربي)",
      bodyEn: "Notification Text (English)",
      nameArPlaceholder: "مثال: تم تحديث أوقات العمل",
      nameEnPlaceholder: "e.g. Working Hours Updated",
      bodyArPlaceholder: "اكتب نص التنبيه بالعربي هنا...",
      bodyEnPlaceholder: "Write the notification text in English...",
      needsDetail: "يحتاج تفاصيل إضافية وقت الإرسال (مثل اسم تطبيق أو موضوع تذكرة تُلحق بنهاية النص)",
      placeholderAr: "نص بديل عربي إذا لم يكتب التفاصيل",
      placeholderEn: "Fallback text (English)",
      placeholderArExample: "مثال: [اسم التطبيق]",
      placeholderEnExample: "e.g. [App name]",
      hint: "تلميح حقل التفاصيل بشاشة الإرسال (للموظف، لا يظهر للمطعم)",
      hintPlaceholder: "مثال: اكتب اسم التطبيق، مثال: هنقرستيشن",
      preview: "معاينة",
      previewAr: "الرجاء كتابة اسم القالب ونصه بالعربي لتظهر المعاينة...",
      previewEn: "Write the template name and text in English to preview...",
      save: "حفظ القالب",
      delete: "حذف",
      cancel: "إلغاء التعديل",
      note: "النص العربي والإنجليزي إجباريان لكل قالب — بالإرسال، قوالب \"قائمة الطعام / التقارير / مدير الحساب\" تظهر دائماً للمالك وكل فروعه معاً. خيار الخصوصية لفرع محدد متاح فقط لقوالب \"التذاكر\".",
      required: "فضلاً قم بملء اسم القالب ونص التنبيه باللغتين العربية والإنجليزية قبل الحفظ — يجب ان يكون القالب  جاهز بالّلغتين.",
      saved: "تم حفظ القالب بنجاح",
      confirmDelete: "هل أنت متأكد من حذف هذا القالب؟ .",
    },
    categories: { menu: "قائمة الطعام", manager: "مدير الحساب", report: "التقارير", ticket: "التذاكر", billing: "الفوترة", operations: "العمليات" },
    scope: { owner: "المالك وكل الفروع", ownerOnly: "المالك فقط", branch: "فرع محدد" },
    automated: { sender: "نظام LUD", badge: "تلقائي", open: "عرض التفاصيل" },
  },
  en: {
    tabs: { inbox: "Notifications", send: "Send Notification", builder: "Template Builder" },
    metrics: { total: "Total Notifications", unread: "Unread", read: "Read" },
    filters: {
      all: "All",
      menu: "Menu",
      manager: "Account Manager",
      report: "Reports",
      ticket: "Tickets",
      billing: "Billing",
      operations: "Operations",
      allRestaurants: "All restaurants",
      allBranches: "All branches",
      allStatuses: "All statuses",
      unread: "Unread",
      read: "Read",
      noNotifications: "No notifications match this filter",
    },
    send: {
      success: "Notification sent successfully",
      successSub: "It will reach the restaurant immediately",
      newNotification: "New Notification",
      category: "Category",
      general: "General Notifications",
      ticket: "Tickets",
      hint: "Menu / Reports / Account Manager notifications always appear to the account owner and all branches together. Branch privacy is available only for tickets.",
      template: "Template",
      preview: "Notification Preview",
      recipientPreview: "Recipient:",
      recipientEmpty: "—",
      selectTemplateAr: "اختر قالباً لتظهر المعاينة...",
      selectTemplateEn: "Select a template to preview...",
      arabic: "Arabic",
      english: "English",
      recipient: "Recipient",
      single: "One restaurant",
      multiple: "Multiple restaurants",
      recipientRestaurant: "Recipient restaurant",
      selectRestaurant: "— Select restaurant —",
      recipientRestaurants: "Recipient restaurants",
      scope: "Notification scope",
      ownerAndBranches: "Owner + all branches",
      ownerOnly: "Owner only",
      branch: "Specific branch",
      recipientBranch: "Recipient branch",
      selectBranch: "— Select branch —",
      visibility: "Who can see this notification?",
      ownerSeesToo: "Also appears to the account owner in addition to the selected branch",
      ownerSeesHint: "Disabling this makes the notification private to this branch only and hidden from the account owner.",
      note: "Additional details (optional)",
      notePlaceholder: "Add manual details...",
      send: "Send Notification",
      sentNotifications: "Sent Notifications",
      noSent: "No sent notifications yet.",
      details: "Details: ",
      supportTeam: "Support Team",
      you: "You",
      now: "Now",
      privateBranch: "private to branch only",
      ownerVisible: "also visible to owner",
      restaurantsCount: "restaurants",
    },
    builder: {
      title: "Template Builder",
      intro: "Create, edit, and delete notification templates for each section. Templates are saved permanently in this browser and appear directly in the Send Notification tab.",
      section: "Section",
      templates: "Templates",
      newTemplate: "New Template",
      editTemplate: "Edit Template",
      noTemplates: "No templates in this section yet.",
      templateNameAr: "اسم القالب (عربي)",
      templateNameEn: "Template Name (English)",
      bodyAr: "نص التنبيه (عربي)",
      bodyEn: "Notification Text (English)",
      nameArPlaceholder: "مثال: تم تحديث أوقات العمل",
      nameEnPlaceholder: "e.g. Working Hours Updated",
      bodyArPlaceholder: "اكتب نص التنبيه بالعربي هنا...",
      bodyEnPlaceholder: "Write the notification text in English...",
      needsDetail: "Needs additional details at sending time, such as an app name or ticket subject appended to the text",
      placeholderAr: "نص بديل عربي إذا ما كُتبت التفاصيل",
      placeholderEn: "Fallback text (English)",
      placeholderArExample: "مثال: [اسم التطبيق]",
      placeholderEnExample: "e.g. [App name]",
      hint: "Details field hint in the sending screen, for staff only and not visible to the restaurant",
      hintPlaceholder: "Example: write app name, e.g. HungerStation",
      preview: "Preview",
      previewAr: "اكتب اسم القالب ونصه بالعربي لتظهر المعاينة...",
      previewEn: "Write the template name and text in English to preview...",
      save: "Save Template",
      delete: "Delete",
      cancel: "Cancel Edit",
      note: "Arabic and English text are required for every template — when sending, Menu / Reports / Account Manager templates always appear to the owner and all branches together. Specific branch privacy is available only for Ticket templates.",
      required: "Please fill the template name and notification text in both Arabic and English before saving.",
      saved: "Template saved successfully",
      confirmDelete: "Are you sure you want to delete this template? This cannot be undone.",
    },
    categories: { menu: "Menu", manager: "Account Manager", report: "Reports", ticket: "Tickets", billing: "Billing", operations: "Operations" },
    scope: { owner: "Owner and all branches", ownerOnly: "Owner only", branch: "Specific branch" },
    automated: { sender: "LUD System", badge: "Automatic", open: "View details" },
  },
};

export const getText = (lang) => TEXT[lang] || TEXT.ar;

// Automated notifications (backend services/notifications) carry an in-app destination. Only a path
// inside the authenticated app is followed; the route guards decide whether the user may open it.
export const isAutomated = (notification) => notification?.source === "automated";
export const getNotificationLink = (notification) => {
  const link = String(notification?.link || "");
  return isAutomated(notification) && /^\/auth\/[\w/?=&.-]*$/.test(link) ? link : "";
};
export const isArabic = (lang) => lang === "ar";

export const getLocalized = (item, arKey, enKey, lang) => {
  if (!item) return "";
  return isArabic(lang) ? item[arKey] || item[enKey] || "" : item[enKey] || item[arKey] || "";
};

export const getOwnerByBranchId = (restaurants, branchId) => {
  return restaurants.find((owner) => owner.branches?.some((branch) => branch.id === branchId));
};

export const getBranchById = (restaurants, branchId) => {
  const owner = getOwnerByBranchId(restaurants, branchId);
  return owner?.branches?.find((branch) => branch.id === branchId) || null;
};

export const buildNotificationBody = (template, note) => {
  const value = note?.trim() || "";
  let ar = template.bodyAr || "";
  let en = template.bodyEn || "";

  if (template.needsDetail) {
    ar += value || template.placeholderAr || "[التفاصيل]";
    en += value || template.placeholderEn || "[Details]";
  } else if (value) {
    ar += `\n\nتفاصيل: ${value}`;
    en += `\n\nDetails: ${value}`;
  }

  return { ar, en };
};

export const getScopeLabel = ({ restaurants, scope, lang }) => {
  const t = getText(lang);
  const data = scope || {};
  const owner = restaurants.find((item) => item.id === data.ownerId);
  const branch = getBranchById(restaurants, data.branchId);
  const ownerName = getLocalized(owner, "name", "nameEn", lang);
  const branchName = getLocalized(branch, "name", "nameEn", lang);

  if (data.level === "branch") {
    return branchName || t.scope.branch;
  }

  if (data.level === "owner-only") {
    return ownerName ? `${ownerName} — ${t.scope.ownerOnly}` : t.scope.ownerOnly;
  }

  return ownerName ? `${ownerName} — ${t.scope.owner}` : t.scope.owner;
};

export const getRecipientLabel = ({
  restaurants,
  recipientMode,
  ownerId,
  ownerIds,
  scope,
  branchId,
  ownerSeesToo,
  composeCategory,
  lang,
}) => {
  const t = getText(lang);

  if (recipientMode === "multiple") {
    if (!ownerIds.length) return "";
    const names = ownerIds
      .map((id) => restaurants.find((owner) => owner.id === id))
      .filter(Boolean)
      .map((owner) => getLocalized(owner, "name", "nameEn", lang));
    const scopeLabel = scope === "owner-only" ? t.send.ownerOnly : t.send.ownerAndBranches;
    return `${names.length} ${t.send.restaurantsCount} (${scopeLabel}): ${names.join("، ")}`;
  }

  const owner = restaurants.find((item) => item.id === ownerId);
  if (!owner) return "";

  const ownerName = getLocalized(owner, "name", "nameEn", lang);

  if (scope === "branch" && branchId) {
    const branch = owner.branches.find((item) => item.id === branchId);
    const branchName = getLocalized(branch, "name", "nameEn", lang);
    const suffix = composeCategory === "ticket" && !ownerSeesToo ? t.send.privateBranch : t.send.ownerVisible;
    return `${branchName} (${suffix})`;
  }

  if (scope === "owner-only") return `${ownerName} — ${t.send.ownerOnly}`;

  return `${ownerName} — ${t.send.ownerAndBranches}`;
};

export const getTemplateGroups = (templates, lang, access='manager') => 
  access==='menu'?
([
  { key: "menu", label: getText(lang).categories.menu, list: templates.menu || [] },
])
:
  access==='report'?
([
  { key: "report", label: getText(lang).categories.report, list: templates.report || [] },
])
:
([
  { key: "manager", label: getText(lang).categories.manager, list: templates.manager || [] },
  { key: "menu", label: getText(lang).categories.menu, list: templates.menu || [] },
  { key: "report", label: getText(lang).categories.report, list: templates.report || [] },
]);
